module.exports = __webpack_public_path__ + "img/jdm5.af6b49ff.jpg";